import { Intent } from './types'
import { Locale } from '@/ux/types'
import { translations } from '@/i18n/translations'

export function getIntents(locale: Locale): Intent[] {
  const t = translations[locale].assistant.intents

  return [
    {
      id: 'realtime-market-pipeline',
      label: t.realtimeMarketPipeline.label,
      icon: '🚀',
      description: t.realtimeMarketPipeline.description,
      response: t.realtimeMarketPipeline.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'setPersona', value: 'engineer' },
          { type: 'navigate', path: '/projects/realtime-market-pipeline' },
        ],
      },
    },
    {
      id: 'recruiter-overview',
      label: t.recruiterOverview.label,
      icon: '👔',
      description: t.recruiterOverview.description,
      response: t.recruiterOverview.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'setPersona', value: 'recruiter' },
          { type: 'navigate', path: '/' },
        ],
      },
    },
    {
      id: 'engineer-overview',
      label: t.engineerOverview.label,
      icon: '💻',
      description: t.engineerOverview.description,
      response: t.engineerOverview.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'setPersona', value: 'engineer' },
          { type: 'navigate', path: '/' },
        ],
      },
    },
    {
      id: 'gamer-view',
      label: t.gamerView.label,
      icon: '🎮',
      description: t.gamerView.description,
      response: t.gamerView.response,
      action: {
        type: 'navigate',
        path: '/game',
      },
    },
    {
      id: 'engineer-cicd',
      label: t.engineerCicd.label,
      icon: '🔧',
      description: t.engineerCicd.description,
      response: t.engineerCicd.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'setPersona', value: 'engineer' },
          { type: 'navigate', path: '/projects/demo-cicd-prod-pipeline' },
        ],
      },
    },
    {
      id: 'engineer-data',
      label: t.engineerData.label,
      icon: '📊',
      description: t.engineerData.description,
      response: t.engineerData.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'setPersona', value: 'engineer' },
          { type: 'navigate', path: '/projects/demo-data-airflow-duckdb' },
        ],
      },
    },
    {
      id: 'ai-data-assistant',
      label: t.aiDataAssistant.label,
      icon: '🤖',
      description: t.aiDataAssistant.description,
      response: t.aiDataAssistant.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'setPersona', value: 'engineer' },
          { type: 'navigate', path: '/projects/demo-ai-data-assistant' },
        ],
      },
    },
    {
      id: 'terraform-multicloud',
      label: t.terraformMulticloud.label,
      icon: '☁️',
      description: t.terraformMulticloud.description,
      response: t.terraformMulticloud.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'setPersona', value: 'engineer' },
          { type: 'navigate', path: '/projects/demo-terraform-multicloud' },
        ],
      },
    },
    {
      id: 'ai-tools',
      label: t.aiTools.label,
      icon: '🤖',
      description: t.aiTools.description,
      response: t.aiTools.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'navigate', path: '/' },
          { type: 'scrollTo', selector: '#ai-tools' },
        ],
      },
    },
    {
      id: 'contact',
      label: t.contact.label,
      icon: '📧',
      description: t.contact.description,
      response: t.contact.response,
      action: {
        type: 'composite',
        actions: [
          { type: 'navigate', path: '/' },
          { type: 'scrollTo', selector: '#contact' },
        ],
      },
    },
  ]
}
